import React from "react";
import { FileUpload } from "primereact";
import Costanti from "../constantiX";
import { useToast } from "../hooks/use-toast";

const UploadImg = ({ aziendaId, itemId, label, table, isDirty }) => {
  const { toastRef } = useToast();
  return (
    <FileUpload
      disabled={isDirty}
      mode="basic"
      name="product-image"
      url={Costanti.UrlCallApi + "file/carica/" + aziendaId + "/" + table + "/" + itemId}
      onError={() => toastRef.current.showMessage("error", "Errore", "Si è verificato un errore nel caricamento")}
      onUpload={() => window.location.reload(false)}
      onValidationFail={() => toastRef.current.showMessage("error", "Errore", "Dimensione file errato")}
      accept={`image/*, video/*, application/pdf , ${table === "processo" ? "video/*" : ""}`}
      maxFileSize={10000000}
      chooseOptions={{ className: "p-button-plain p-button-outlined" }}
      chooseLabel={label || "Carica file"}
    />
  );
};

export default UploadImg;
